import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Ygalaad</p>
      {/* <div className="social-media" style={{marginRight: "1rem"}}>
        <a href="https://twitter.com">Twitter</a>
        <a href="https://facebook.com">Facebook</a>
        <a href="https://instagram.com">Instagram</a>
      </div> */}
      <a className="footer-link" href="/privacy-policy">Privacy Policy</a>
    </footer>
  );
}

export default Footer;
